import { useNavigation } from "@react-navigation/native";
import { CardStyleInterpolators } from "@react-navigation/stack";
import {
  PartialPage,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import { useCallback } from "react";
import { PermissionToken } from "../../../../utilities/permissions/constants";
import { PermissionConfigScreen } from "../../components";

export function PermissionsModalRootScreen() {
  const navigation = useNavigation<any>();
  const Stack = createStackHeaderNavigator();

  const handleOnClose = () => {
    navigation.pop(2);
  };

  const CameraPermissionScreen = useCallback(
    () => (
      <PermissionConfigScreen
        onDeny={handleOnClose}
        onGrant={() => console.log("GRANTED")}
        permissionToken={PermissionToken.Camera}
        unsetMessage="We need your permission to show the camera."
        deniedMessage="Camera permission denied. Please enable camera permissions in device settings."
        cantAskMessage="Camera permission denied and can't ask again. Please enable camera permissions in device settings."
      />
    ),
    []
  );

  // NOTE: the min height is a temp hack since dynamic content sizes in modal navigator presents issues
  return (
    <PartialPage
      scrollable={false}
      size="compact"
      onClose={handleOnClose}
      contentContainerStyle={{ flex: 1 }}
      animatedViewStyles={{
        maxHeight: "auto",
        height: "auto",
        minHeight: "400px",
      }}
    >
      <Stack.Navigator
        screenOptions={{
          headerShown: false,
          cardStyle: {
            display: "flex",
            flexShrink: 1,
            height: "auto",
            maxHeight: "auto",
          },
        }}
      >
        <Stack.Group
          screenOptions={{
            animationEnabled: true,
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          }}
        >
          <Stack.Screen
            name="CameraPermissionScreen"
            component={CameraPermissionScreen}
          />
        </Stack.Group>
      </Stack.Navigator>
    </PartialPage>
  );
}
